import { IView } from "../Core/View";
import { ViewFactory } from "../Core/Factories/ViewFactory";

import { ContactView } from "./Home/ContactView";
import { FaqView } from "./Home/FaqView";
import { IndexView } from "./Home/IndexView";

ViewFactory.setRegistry({
    'ContactView': ContactView,
    'FaqView': FaqView,
    'IndexView': IndexView
});


// WEBPACK FOOTER //
// ./www/js/Pages/Home.ts